<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div class="containerIconClose" @click="linkTo(cardContent.navigate.close.action)">
        <font-awesome-icon icon="times" class="IconClose"/>
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow alignHorizontal="between" alignVertical="center" class="mr-2 ml-2">
          <h3
            :class="checkLangClass()+' m-2'"
          >{{checkLanguage(cardContent.title)}} : {{checkLanguage(cardContent.description)}}</h3>
        </CRow>
      </CCardHeader>
      <CCardBody class="pt-2 pb-3 pr-2 pl-2">
        <ComponentVS :cardContent="cardContent" />
        <CCol xl="12" lg="12" md="12" sm="12" xs="12">
          <!-- <CRow
            align-vertical="center"
            align-horizontal="center"
            style="position:absolute; z-index: 1; bottom:10%; left:43%;"
          >-->
          <CRow align-vertical="center" align-horizontal="center">
            <CButton
              color="danger"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5"
              @click="linkTo(cardContent.navigate.previous.action)"
            >PREV</CButton>
            <CButton
              color="success"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5"
              @click="linkTo(cardContent.navigate.next.action)"
            >NEXT</CButton>
          </CRow>
        </CCol>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import ComponentVS from "./ComponentVS";
import { mapGetters } from "vuex";
import "../../../assets/scss/_chineseStyle.scss";
import "../../../assets/scss/_chineseIcon.scss";
export default {
  components: { ComponentVS },
  name: "CardVS",
  props: { cardContent: Object, updateUser: Function, },
  data() {
    return {
      lang: "",
    };
  },

  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },

  watch: {
    getLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {
    //
  },

  created() {
    this.lang = this.$store.state.language.language;
    this.playSoundEffect();
  },

  beforeDestroy() {},
  methods: {
    playSoundEffect(){
      let sound = new Audio("https://mdl.mfu.ac.th/chinese/Sound/Effect/VS/Weapon%20Metal%20Scrape%20Sword%20Scrape%2001.mp3");
      sound.play();
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    // linkTo(path) {
    //   this.$router.push(path);
    // },
    linkTo(tempId) {
      let str = tempId.split("-");
      let path = "/" + str[0] + "/" + str[1]
      this.$emit("updateUser", path);
      
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    close() {
      let str = this.cardContent.navigate.close.action.split("-");
      this.$router.push("/" + str[0] + "/" + str[1]);
    },
  },
};
</script>
<style>
/* .userLeft{
    width: 10rem;
    height: 10rem;
} */
</style>